var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.errorMessage)?_c('p',{staticStyle:{"color":"red","margin-bottom":"8px"}},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]):_vm._e(),_c('div',{attrs:{"id":"stripe-payment-element"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }